// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"fa9c9dc2","256":"e737064f","320":"d5bd36ac","329":"86117a54","535":"652fab63","922":"9a9f1233","991":"0a40e8e0"}[chunkId] + ".chunk.js";
};